<template>
    <div class="mvt-mortgage-new" v-if="mounted">
        <div id="topLink" v-if="topVeteran && topVeteran.id">
            <a class="link" @click="show3rdPartyForm(topVeteran.id, 'veteransUnited2',topVeteran.cta)" rel="nofollow noreferrer" role="button">{{topVeteran.cta}}</a>
        </div>
        <div v-if="pricePerMonth > 0">
            <div class="f0 text-bold lh-normal">
                Est. {{$filters.formatPrice(pricePerMonth)}}/mo
            </div>
            <div class="text-bold text-sentencecase">
                {{pricePerMonthDesc}}
            </div>
        </div>
        <a v-if="mortgageCtaObj" class="btn primary medium" @click="showForm(mortgageCtaObj)" role="button">
            {{mortgageCtaObj.cta}}
        </a>
        <div class="calculator" v-ga:impression="'mortgage-rates'">
            <div class="shown">
                <div class="group">
                    <mvtTextbox>
                        <div class="input left">
                            <label for="homePrice">Home price</label>
                            <b class="text-a">$</b>
                            <mvtInputNumber id="homePrice" v-model="homePrice" @input="algothrim" />
                        </div>
                    </mvtTextbox>
                    <mvtTextbox>
                        <div class="input right">
                            <label for="interestRate">Interest rate</label>
                            <mvtInputDecimalNumber id="interestRate" v-model="interestRate" @input="algothrim"/>
                            <b class="text-a">%</b>
                        </div>
                    </mvtTextbox>
                </div>
                <div class="group merge">
                    <mvtTextbox>
                        <div class="input left">
                            <label for="downpayment">Down payment</label>
                            <b class="text-a">$</b>
                            <mvtInputNumber id="downpayment" v-model="downpayment" @input="$event=>updateDownPayment(true)" />
                        </div>
                    </mvtTextbox>
                    <mvtTextbox>
                        <div class="input right">
                            <mvtInputDecimalNumber v-model="downpaymentRate" @input="$event=>updateDownPayment(false)" :aria-label="`Down payment rate`"/>
                            <b class="text-a">%</b>
                        </div>
                    </mvtTextbox>
                </div>
            </div>
            <div>
                <button class="mortgage-toggle-link" data-role="toggle" data-id="PI" type="button">
                    <div>Principal and interest</div>
                    <div class="m-l-auto"><span v-if="loanPerMonth>=0">{{!loanPerMonth ? `$0` : $filters.formatPrice(loanPerMonth)}}</span> </div>
                </button>
                <div class="group wrap">
                    <div>
                        <div class="label">Loan type</div>
                        <mvtSelect :data="interestRateList" v-model="interestRateIndex" placeholder="Loan Type" @change="updateInterstRate" />
                    </div>
                    <div>
                        <div class="label">Estimated credit score</div>
                        <mvtSelect :data="creditList"  v-model="credit" />
                    </div>
                </div>
            </div>
            <div>
                <button class="mortgage-toggle-link" data-role="toggle" data-id="propertyTax" type="button">
                    <div>Property taxes</div>
                    <div class="m-l-auto"><span v-if="taxPerMonth">{{$filters.formatPrice(taxPerMonth)}}</span> </div>
                </button>
                <div class="group merge">
                    <div class="input left">
                        <b class="text-a">$</b>
                        <mvtInputNumber id="propertyTax" v-model="propertyTax" @input="$event=>updateTaxRate(true)" :suffix="' /year'"/>
                    </div>

                    <div class="input right">
                        <mvtInputDecimalNumber id="propertyTaxRate" v-model="propertyTaxRate" @input="$event=>updateTaxRate(false)"/>
                        <b class="text-a">%</b>
                    </div>
                </div>
            </div>
            <div>
                <button class="mortgage-toggle-link" data-role="toggle" data-id="homeInsurance" type="button">
                    <div>Homeowners insurance</div>
                    <div class="m-l-auto"><span v-if="homeInsurancePerMonth">{{$filters.formatPrice(homeInsurancePerMonth)}}</span></div>
                </button>
                <div class="group">
                    <div class="input left right">
                        <b class="text-a">$</b>
                        <mvtInputNumber id="homeInsurance" v-model="homeInsurance" @input="algothrim"/>
                        <b class="text-a">/year</b>
                    </div>
                </div>
            </div>
            <div v-show="pmiPerMonth">
                <button class="mortgage-toggle-link" data-role="toggle" data-id="mortgageInsurance" type="button">
                    <div>Mortgage insurance</div>
                    <div class="m-l-auto"><span>{{$filters.formatPrice(pmiPerMonth)}}</span></div>
                </button>
                <div class="f6">
                    <div>
                        Mortgage insurance protects the lender and is usually required for down payments below 20%. It is typically .5-1.5% of the principle.
                    </div>
                </div>
            </div>
            <div v-show="propertyHoafee">
                <button class="mortgage-toggle-link" data-role="toggle" data-id="monthlyHOA" type="button">
                    <div>Homeowners association (HOA)</div>
                    <div class="m-l-auto"><span v-if="hoaPerMonth">{{$filters.formatPrice(hoaPerMonth)}}</span></div>
                </button>
                <div class="group">
                    <mvtTextbox>
                        <div class="input left">
                            <label for="propertyHoafee">{{molang('dpp.propertyMortgage.monthlyHoa')}}</label>
                            <b class="text-a">$</b>
                            <mvtInputNumber id="propertyHoafee" v-model="propertyHoafee" @input="algothrim"/>
                        </div>
                    </mvtTextbox>
                </div>
            </div>
            <div :class="{shown:openIACProvider}" v-if="internetCableMonthly">
                <button class="mortgage-toggle-link" @click="toogleIACProvider" type="button">
                    <div>Internet and cable</div>
                    <div class="m-l-auto"><span>${{internetCableMonthly}}</span></div>
                </button>
                <internetcableProvider :zipcode="zipcode" :state="state" :city="city"/>
            </div>

            <div :class="{shown:openMorgage}">
                <button class="mortgage-toggle-link" @click="toggleMortgageSection" type="button">
                    <span>Mortgage rates</span>
                </button>
                <div v-if="openMorgage" class="mortgage-panel" :class="{less: !showAll}">
                    <span class="f6" v-if="!cordlessLoaded">{{mortgageRateSubHeader}}</span>
                    <template v-if="sortedMortgageResult && sortedMortgageResult.length">
                        <mvtCardMortgageNew v-for="item in sortedMortgageResult" :data="item" :openMortgage="openMorgage" :provider="providerNameForMR" :key="item.cpc + item.NMLS" :state="state" />
                        <div v-if="sortedMortgageResult.length > 3" class="f6 link-toggle">
                            <a  @click="toogleLink" class="link" :class="{'shown':showAll}" role="button">{{showAll ? 'Show fewer mortgage rates' : 'Show all mortgage rates'}} <i :class="{'icon-angle-down': !showAll, 'icon-angle-up': showAll}"></i></a>
                        </div>
                        <div v-if="isBankRate">
                            <bankrateFooter/>
                        </div>
                        <div v-else-if="informaDisclaimer && !cordlessLoaded"  class="f6 text-gray">
                            <a class="underdash advertiserDisclosure" v-if="informaDisclosureContent" href="javascript:;" rel="nofollow" role="button" v-tip :tip="informaDisclosureContent">Advertiser Disclosure</a>.
                            <span v-html="informaDisclaimer"></span>
                        </div>
                    </template>
                    <template v-else-if="mortgageRatesLoaded && !cordlessLoaded">
                        <div>
                            <b>{{molang('dpp.propertyMortgage.noMatch')}}</b>
                        </div>
                        <div class="f6">
                            <a @click="showLowrateForm" class="link" role="button">
                                {{molang('dpp.propertyMortgage.connectLocalLender')}}
                                <br>
                                {{molang('dpp.propertyMortgage.findLowRate')}}
                            </a>
                        </div>
                    </template>
                </div>
            </div>
            <mvtLazyload>
                <additionalServices :zipcode="zipcode" :state="state" :city="city" :price="price"  :propertyType="propertyType" :yearBuilt="yearBuilt" />
            </mvtLazyload>
            <button v-if="isActive" class="link" @click="show3rdPartyForm('checkYourCredit', 'credit')" type="button">Check your credit before you buy</button>
        </div>
    </div>
</template>
<script src="./mvt-mortgage-new.js"></script>

<style lang="scss">
@use "./mvt-mortgage-new.scss" as *;
</style>
